import { gql } from 'apollo-angular';

export const GET_ALL_PROPOSALS = gql`
  query ProposalFindAll(
    $orderBy: [ProposalOrderByWithRelationAndSearchRelevanceInput!]
    $skip: Int
    $take: Int
    $where: ProposalWhereInput
  ) {
    ProposalFindAll(
      orderBy: $orderBy
      skip: $skip
      take: $take
      where: $where
    ) {
      id
      paymentCondition {
        name
      }
      productRequest {
        number
      }
      reference
      status {
        name
      }
      total
      inconTermId
      tempoEmbarque
      validade
      currency {
        id
        name
      }
      Proposal2Client {
        clientId
        client {
          id
          name
        }
      }
      ProductOffer2Proposal {
        id
        product {
          originPort {
            name
            id
          }
        }
        freight {
          id
          destinyPort {
            id
            name
          }
        }
        additionalCosts {
          id
          type
          freight {
            id
            destinyPort {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_PROPOSALS_BY_ID = gql`
  query ProposalFindOne($where: ProposalWhereUniqueInput!) {
    ProposalFindOne(where: $where) {
      id
      notes
      paymentCondition {
        id
        isActive
        name
      }
      paymentConditionId
      inconTermId
      tempoEmbarque
      productRequest {
        id
        destinyPortId
        client {
          name
          externalCode
        }
        date
        destinyCountry {
          id
          name
          cca3
          cca2
        }
        destinyPort {
          id
          internalId
          name
          countryId
          country {
            id
            name
            cca3
            cca2
          }
        }
        notes
        number
        offerDate
        specy {
          id
          name
        }
        quantity {
          quantity
          id
          quantityType {
            name
            quantityInM3
            id
          }
        }
      }
      reference
      status {
        id
        name
      }
      validade
      total
      pdfDownloadCount
      emailsSentCount
      statusId
      productRequestId
      currencyId
      currency {
        id
        name
      }
      countryId
      country {
        id
        cca3
        cca2
      }
      Proposal2Client {
        clientId
        client {
          id
          name
          externalCode
          Port2Clients {
            portId
          }
        }
      }
      ProductOffer2Proposal {
        id
        inconTerm {
          id
          name
        }
        inconTermId
        volumeM3
        lineTotal
        freightIncomplete
        containersOverridden
        transportMode
        quantityOverrideM3
        requestedVolumeM3
        idleCapacityM3
        containers {
          id
          quantityTypeId
          count
          capacityM3
          quantityType {
            id
            name
            quantityInM3
          }
        }
        breakdown {
          volumeM3
          woodPerM3
          freightPerM3
          otherIncludedPerM3
          excludedPerM3
          roundingPerM3
          unitPrice
          woodTotal
          freightTotal
          otherIncludedTotal
          excludedTotal
          lineTotal
          freightIncomplete
        }
        product {
          id
          inconTermId
          length
          number
          obs
          originPort {
            id
            name
            countryId
            country {
              cca3
              name
              cca2
              id
            }
          }
          fsc
          dryTypeId
          dryType {
            id
            name
          }
          date
          Pricings {
            id
            isMainCurrency
            value
            currencyId
            currency {
              id
              name
            }
          }
          InconTerm {
            id
            name
          }
          productOfferState {
            id
            name
          }
          profitMargin
          salePrice
          bulkPrice
          bulkSalePrice
          woodTotal
          volumeM3
          requestedVolumeM3
          idleCapacityM3
          containers {
            quantityTypeId
            count
          }
          qualityType {
            id
            name
          }
          quantity {
            id
            quantity
            quantityType {
              name
              quantityInM3
              id
            }
            calculatedQuantity
          }
          sawnType {
            id
            name
          }
          shipment {
            id
            name
            via
          }
          specy {
            id
            name
            appliesImportTax
          }
          supplier {
            id
            externalCode
            name
          }
          supplierType
          via
          width
          thick
        }
        freight {
          Pricing {
            id
            isMainCurrency
            value
            currencyId
            currency {
              id
              isActive
              name
            }
          }
          company {
            id
            name
          }
          companyId
          continent
          destinyCountry {
            id
            name
          }
          destinyCountryId
          destinyPort {
            countryId
            country {
              id
              name
              cca2
              cca3
            }
            name
          }
          destinyPortId
          freightTypeId
          freightType {
            id
            name
          }
          originPort {
            id
            name
            countryId
            country {
              id
              name
              cca3
              cca2
            }
          }
          ql
          tt
          validity
          via
        }
        additionalCosts {
          id
          type
          description
          value
          supplierReference
          internalNote
          freightId
          basisAmount
          basisQuantityTypeId
          totalAmount
          freight {
            id
            validity
            freightType {
              id
              name
              quantityTypeId
            }
            company {
              id
              name
            }
            originPort {
              id
              name
            }
            destinyPort {
              id
              name
              country {
                id
                name
              }
            }
            via
            tt
          }
        }
      }
    }
  }
`;

export const ADD_PROPOSAL = gql`
  mutation ProposalCreate($data: ProposalCreateInput!) {
    ProposalCreate(data: $data) {
      id
    }
  }
`;

export const UP_PROPOSAL = gql`
  mutation ProposalUpdate(
    $data: ProposalUpdateInput!
    $where: ProposalWhereUniqueInput!
  ) {
    ProposalUpdate(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_PROPOSAL = gql`
  mutation ProposalDelete($where: ProposalWhereUniqueInput!) {
    ProposalDelete(where: $where) {
      id
    }
  }
`;

export const GET_PROPOSALS_TRASH = gql`
  query ProposalTrash(
    $orderBy: [ProposalOrderByWithRelationAndSearchRelevanceInput!]
    $skip: Int
    $take: Int
    $where: ProposalWhereInput
  ) {
    ProposalTrash(
      orderBy: $orderBy
      skip: $skip
      take: $take
      where: $where
    ) {
      id
      paymentCondition {
        name
      }
      productRequest {
        number
      }
      reference
      status {
        name
      }
      total
      inconTermId
      tempoEmbarque
      validade
      currency {
        id
        name
      }
      Proposal2Client {
        clientId
        client {
          id
          name
        }
      }
      ProductOffer2Proposal {
        id
        product {
          originPort {
            name
            id
          }
        }
        freight {
          id
          destinyPort {
            id
            name
          }
        }
        additionalCosts {
          id
          type
          freight {
            id
            destinyPort {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const RESTORE_PROPOSAL = gql`
  mutation ProposalRestore($where: ProposalWhereUniqueInput!) {
    ProposalRestore(where: $where) {
      id
    }
  }
`;

export const PROPOSAL_EMAIL_MODE = gql`
  query ProposalEmailMode {
    ProposalEmailMode {
      live
      testRecipient
    }
  }
`;

export const SEND_PROPOSAL = gql`
  mutation ProposalSend($id: Int!, $clientIds: [Int!], $internalEmail: String) {
    ProposalSend(id: $id, clientIds: $clientIds, internalEmail: $internalEmail) {
      successCount
      failures {
        clientId
        clientName
        reason
      }
    }
  }
`;

// export const UP_REQUEST = gql`
//   mutation ProductRequestUpdate(
//     $data: ProductRequestUpdateInput!
//     $where: ProductRequestWhereUniqueInput!
//   ) {
//     ProductRequestUpdate(data: $data, where: $where) {
//       id
//     }
//   }
// `;

// export const DELETE_REQUEST_MUTATION = gql`
//   mutation ProductRequestDelete($where: ProductRequestWhereUniqueInput!) {
//     ProductRequestDelete(where: $where) {
//       id
//     }
//   }
// `;

export const PROPOSAL_STATUS = gql`
  query ProposalStatusFindAll {
    ProposalStatusFindAll {
      id
      isActive
      name
    }
  }
`;

export const GET_PROPOSAL_HISTORY = gql`
  query ProposalHistoryFindMany($proposalId: Int!) {
    ProposalHistoryFindMany(proposalId: $proposalId) {
      id
      type
      summary
      changes
      actorName
      createdAt
    }
  }
`;

/**
 * Backend-computed fields of one proposal line (ProductOffer2Proposal), shared by the three
 * line mutations so they always return the same shape. Plain string on purpose: graphql-tag
 * inlines it without fragments, so Apollo cache normalisation is unchanged.
 */
const PROPOSAL_LINE_QUANTITY_FIELDS = `
  id
  volumeM3
  lineTotal
  freightIncomplete
  containersOverridden
  transportMode
  quantityOverrideM3
  requestedVolumeM3
  idleCapacityM3
  containers {
    id
    quantityTypeId
    count
    capacityM3
    quantityType {
      id
      name
      quantityInM3
    }
  }
  breakdown {
    volumeM3
    woodPerM3
    freightPerM3
    otherIncludedPerM3
    excludedPerM3
    roundingPerM3
    unitPrice
    woodTotal
    freightTotal
    otherIncludedTotal
    excludedTotal
    lineTotal
    freightIncomplete
  }
  additionalCosts {
    id
    type
    description
    value
    supplierReference
    internalNote
    freightId
    basisAmount
    basisQuantityTypeId
    totalAmount
    freight {
      id
      validity
      freightType {
        id
        name
        quantityTypeId
      }
      company {
        id
        name
      }
      originPort {
        id
        name
      }
      destinyPort {
        id
        name
        country {
          id
          name
        }
      }
      via
      tt
    }
  }
`;

export const PROPOSAL_LINE_SET_CONTAINERS = gql`
  mutation ProposalLineSetContainers(
    $lineId: Int!
    $containers: [ProposalLineContainerInput!]!
  ) {
    ProposalLineSetContainers(lineId: $lineId, containers: $containers) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

export const PROPOSAL_LINE_SET_QUANTITY = gql`
  mutation ProposalLineSetQuantity($lineId: Int!, $quantity: Float!) {
    ProposalLineSetQuantity(lineId: $lineId, quantity: $quantity) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

/** Ships the line in containers or in bulk (the offer's bulk price, per m3); the backend clears what the old mode used. */
export const PROPOSAL_LINE_SET_TRANSPORT_MODE = gql`
  mutation ProposalLineSetTransportMode($lineId: Int!, $mode: TransportMode!) {
    ProposalLineSetTransportMode(lineId: $lineId, mode: $mode) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

/** D19: edits the requested volume (m3) of a line with exactly ONE container type; the backend recomputes the count. */
export const PROPOSAL_LINE_SET_VOLUME = gql`
  mutation ProposalLineSetVolume($lineId: Int!, $volumeM3: Float!) {
    ProposalLineSetVolume(lineId: $lineId, volumeM3: $volumeM3) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

/** D20: puts a legacy m3 offer line in containers of the chosen type. */
export const PROPOSAL_LINE_SET_CONTAINER_TYPE = gql`
  mutation ProposalLineSetContainerType($lineId: Int!, $quantityTypeId: Int!) {
    ProposalLineSetContainerType(lineId: $lineId, quantityTypeId: $quantityTypeId) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

/** A FRETE cost whose freight type is not linked to a container type stays pending until the user assigns the type on the line. */
export const PROPOSAL_LINE_ASSIGN_FREIGHT_CONTAINER_TYPE = gql`
  mutation ProposalLineAssignFreightContainerType($costId: Int!, $quantityTypeId: Int!, $capacityM3: Float) {
    ProposalLineAssignFreightContainerType(costId: $costId, quantityTypeId: $quantityTypeId, capacityM3: $capacityM3) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

export const PROPOSAL_LINE_REFRESH_CAPACITY = gql`
  mutation ProposalLineRefreshCapacity($lineId: Int!) {
    ProposalLineRefreshCapacity(lineId: $lineId) {
      ${PROPOSAL_LINE_QUANTITY_FIELDS}
    }
  }
`;

export const GET_PROPOSAL_LINE_CALCULATION_TRACE = gql`
  query ProposalLineCalculationTrace($lineId: Int!) {
    ProposalLineCalculationTrace(lineId: $lineId) {
      subject
      currency
      steps {
        key
        label
        formula
        substituted
        inputs {
          name
          value
          number
          source
        }
        result
        resultNumber
        unit
        note
      }
    }
  }
`;
